export const GET_MEMBER_FORM_DATA = "GET_MEMBER_FORM_DATA"
export const GET_TRANSACTION_ID_MEMBER_FORM = "GET_TRANSACTION_ID_MEMBER_FORM"
export const UPDATE_JSON_ANSWER_MEMBER_FORM = "UPDATE_JSON_ANSWER_MEMBER_FORM"
export const UPDATE_MEMBER_FORM_ANSWER_DATA = "UPDATE_MEMBER_FORM_ANSWER_DATA"
export const UPDATE_MEMBER_FORM_CODE = "UPDATE_MEMBER_FORM_CODE"
export const UPDATE_MEMBER_PEOPLE_ID = "UPDATE_MEMBER_PEOPLE_ID"